"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCancelablePromise = makeCancelablePromise;
/* * *
 * Should Probably Remove this in favor of using Rx. -G
 * * */

function makeCancelablePromise(promise) {
  var hasCanceled_ = false;

  return {
    promise: new Promise(function (resolve, reject) {
      return promise.then(function (r) {
        return hasCanceled_ ? reject({ isCanceled: true }) : resolve(r);
      });
    }),
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/makeCancelablePromise.js
// module id = 480
// module chunks = 0